import { Components, Theme } from "@mui/material";

export const MuiChip: Components<Theme>["MuiChip"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 8,
      fontWeight: 600,
      fontSize: "0.8125rem",
    }),
    colorSuccess: ({ theme }) => ({
      backgroundColor: `${theme.palette.success.main}15`,
      color: theme.palette.success.dark,
    }),
    colorError: ({ theme }) => ({
      backgroundColor: `${theme.palette.error.main}15`,
      color: theme.palette.error.dark,
    }),
    colorWarning: ({ theme }) => ({
      backgroundColor: `${theme.palette.warning.main}15`,
      color: theme.palette.warning.dark,
    }),
    colorInfo: ({ theme }) => ({
      backgroundColor: `${theme.palette.info.main}15`,
      color: theme.palette.info.dark,
    }),
    filled: ({ theme }) => ({
      "&.MuiChip-colorDefault": {
        backgroundColor: theme.palette.grey[100],
        color: theme.palette.text.primary,
      },
    }),
  },
};
